import { makeStyles } from '@surveycake/rc';

export const useStyles = makeStyles([
  [
    'legalText',
	theme => `
		:lang(ar){
			transform: scaleX(-1);
			direction: rtl;
		}
		width: 100%;
		margin-bottom: 15px;
		padding: 0 16px;
		color: ${theme.survey.color.default};
		line-height: 1.4;
		font-size: 14px;
		box-sizing: border-box;
	`
  ] 
]);
